var _path, _path2, _path3, _path4, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 240,
    viewBox: "0 0 320 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#58D7B9",
    d: "M160 160H80v80h80zM160 160v80h80c0-44.176-35.81-80-80-80zM0 0v80h80C80 35.824 44.19 0 0 0zM0 80v80h80c0-44.176-35.81-80-80-80z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240 160v80h80c0-44.176-35.81-80-80-80zM240 80v80h80c0-44.176-35.81-80-80-80z",
    fill: "#B39AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 160v80H0c0-44.176 35.81-80 80-80z",
    fill: "#171718"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320 0v80h-80c0-44.176 35.81-80 80-80z",
    fill: "#59F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    width: 160,
    height: 160,
    rx: 80,
    fill: "#FCE5A5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#connection-complete_svg__filter0_d_1573_14966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.161 40.828a4 4 0 00-5.657 0l-47.17 47.17-13.838-13.837a4 4 0 00-5.657 0l-11.01 11.01a3.998 3.998 0 000 5.656l27.676 27.677a4 4 0 005.657 0l61.009-61.01a3.999 3.999 0 000-5.656l-11.01-11.01z",
    fill: "#2F965D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.627 88.706l.707.707.707-.707 47.17-47.17a3 3 0 014.243 0l11.01 11.009a3 3 0 010 4.243l-61.009 61.009a3 3 0 01-4.243 0L113.536 90.12a3 3 0 010-4.243l11.01-11.01a3 3 0 014.243.001l13.838 13.838z",
    stroke: "#171718",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "connection-complete_svg__filter0_d_1573_14966",
    x: 111.657,
    y: 39.657,
    width: 97.686,
    height: 81.019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0901961 0 0 0 0 0.0941176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1573_14966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1573_14966",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionComplete);
export default __webpack_public_path__ + "static/media/connection-complete.1306356c8958974597c7621bc7ca5995.svg";
export { ForwardRef as ReactComponent };